import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { atom } from 'jotai';
import { createContext } from 'react';

import { TradingLeaderboardInterval } from '@flipster/apis/v2/trading-leaderboards/types';
import { PusdtCurrency, UsdtCurrency } from '@flipster/utils/constants/currency';
import { BigNumber } from '@flipster/utils/num';

import { earnSummaryBunja, getEarnSummaryOfCurrency } from '../../../shared/earn/state';
import { tradingLeaderboardMyRankingBunja } from '../../bunja';

export type RankShareLeagueOption = 'ALL' | 'LEAGUE';

export const RankShareInitialIntervalContext = createContext<TradingLeaderboardInterval>('WEEKLY');
const RankShareInitialIntervalScope = createScopeFromContext(RankShareInitialIntervalContext);
export const rankShareBunja = bunja(() => {
  const { isPendingAtom: isAprPendingAtom, earnSummaryAtom } = bunja.use(earnSummaryBunja);
  const { myRankingsAtom } = bunja.use(tradingLeaderboardMyRankingBunja);

  // max earn calculation: https://www.notion.so/prextech/Apply-refactored-Earn-API-25aeb32ad22780db861de4ac1f5bf443?source=copy_link#270eb32ad2278096b836fdf652b5c5aa
  const maxAprPctAtom = atom((get) => {
    const { maxAprPct: usdtMaxAprPct } = getEarnSummaryOfCurrency(UsdtCurrency, get(earnSummaryAtom));
    const { maxAprPct: pusdtMaxAprPct } = getEarnSummaryOfCurrency(PusdtCurrency, get(earnSummaryAtom));
    return BigNumber.max(usdtMaxAprPct, pusdtMaxAprPct);
  });

  const leagueOptionAtom = atom<RankShareLeagueOption>('ALL');
  const intervalAtom = atom<TradingLeaderboardInterval>(bunja.use(RankShareInitialIntervalScope));

  const rankingAtom = atom((get) => {
    const option = get(leagueOptionAtom);
    const interval = get(intervalAtom);
    const rankings = get(myRankingsAtom) ?? [];
    if (option === 'ALL') {
      return rankings.find((r) => r.league === 'TIERED' && r.interval === interval && r.tier === 'ALL');
    }
    return rankings.find((r) => r.league === 'TIERED' && r.interval === interval && r.tier !== 'ALL');
  });

  const isPendingAtom = atom((get) => get(isAprPendingAtom) || !get(rankingAtom));

  return { isPendingAtom, maxAprPctAtom, rankingAtom, leagueOptionAtom, intervalAtom };
});
rankShareBunja.debugLabel = 'rankShareBunja';
